module.exports = __webpack_public_path__ + "static/media/sustainable-large.5a9f7380.jpg";